module.exports = __webpack_public_path__ + "static/media/utorontologo.11ec10a5.png";